import React, { useEffect, useState } from 'react'
import useFetchInfo from "../../utils/useFetchInfo";
import { useNavigate, useParams } from "react-router-dom";
import apiServer from "../../constants/apiServer";
import "../../css/artist.sass";
import SquareLoading from "../../common/SquareLoading";
import { put } from "../../utils/api";
import PopupLoading from '../../common/PopupLoading';
import AdaAlert from '../../common/AdaAlert';
import { img_url_api } from "../../constants/apiImg";
import { checkFormValidate } from '../../utils/commonFuncs';
import CategoryForm from './CategoryForm';
import EmptyPage from '../../common/EmptyPage';
import { handleApiError, handleApiSuccess } from "../../utils/errorHandler";

const UpdateCategory = () => {

  const navigate = useNavigate();
  const { categoryId } = useParams();


  const [categoryInfoValues, setCategoryInfoValues ] = useState({
    categoryImg: null,
    nameENG: '',
    nameMM: '',
    subCategory: 'no',
    categoryList: [],
    chosenCategory: {}
  })

  const [errorValues, setErrorValues ] = useState({});


  const [getInfoLoading, setGetInfoLoading] = useState(true);
  const [getInfoError, setGetInfoError ] = useState("");


  const [updateCategoryLoading, setUpdateCategoryLoading ] = useState(false);
  const [errorUpdate, setErrorUpdate ] = useState("");

  const { data: categoryList, isLoading: loadingCategoryList, error: categoryListError } = useFetchInfo(apiServer.category.all_list)
  
  const { data: categoryInfo, isLoading: loadingcategoryInfo, error : categoryInfoError } = useFetchInfo(`${apiServer.category.detail}/${categoryId}`);


  useEffect(() => {

    setGetInfoLoading(loadingCategoryList && loadingcategoryInfo);

    setGetInfoError(categoryListError || categoryInfoError);

    let modifiedCategoryList = categoryList.map((element) => {
      return {
        value: element?.id,
        label: `${element?.name?.eng} : ${element?.name?.mm}`
      }
    });

    const availableCategoryList = modifiedCategoryList.filter((element) => element?.value !== categoryId);

    const selectedCategory = categoryInfo?.parent_id === 0 ? availableCategoryList[0] : modifiedCategoryList.filter((element) => element?.value === categoryInfo?.parent_id)[0];

    setCategoryInfoValues({
      categoryImg: img_url_api+categoryInfo?.image,
      nameENG: categoryInfo?.name?.eng,
      nameMM: categoryInfo?.name?.mm,
      subCategory: categoryInfo?.parent_id > 0 ? 'yes' : 'no',
      categoryList: availableCategoryList,
      chosenCategory: selectedCategory,
    })
    

  }, [categoryList, loadingCategoryList, categoryListError, categoryInfo, loadingcategoryInfo, categoryInfoError, categoryId])
  

  const handleChangeValue = ( event ) => {
    const { name, value } = event.target;
    setCategoryInfoValues((prevInfo) => {
      return{
        ...prevInfo,
        [name] : value
      }
    })
  }

  const handleChooseValue = ( selectedOption) => {
    setCategoryInfoValues((prevInfo) => {
      return{
        ...prevInfo,
        chosenCategory: selectedOption
      }
    });
    delete errorValues['chosenCategory'];
    setErrorValues(errorValues);
  }


  const handleUploadImage = (imageInfo) => {
    setCategoryInfoValues((prevInfo) => {
      return {
        ...prevInfo,
        categoryImg: imageInfo
      }
    })
    delete errorValues['categoryImg']
    setErrorValues(errorValues)
  };

  const handleRemoveImage = () => {
    setCategoryInfoValues((prevInfo) => {
      return {
        ...prevInfo,
        categoryImg: null
      };
    });
  };

  const handleCancelUpdate = () => {
    navigate("/categories", { replace : true })
  }

  const handleUpdateCategory = async(event) => {
    event.preventDefault();
    const {categoryImg, nameENG, nameMM, subCategory, chosenCategory } = categoryInfoValues;
    const checkGeneralInfo = checkFormValidate({
      categoryImg,
      nameENG,
      nameMM,
      subCategory,
      chosenCategory
    });
    setErrorValues(checkGeneralInfo);
    const errorStateList = Object.keys(checkGeneralInfo);
    const categoryParentId = subCategory === "yes" ? chosenCategory?.value : 0;
    
    if(errorStateList.length === 0 && nameENG.length <= 100 && nameMM.length <= 100){
      setUpdateCategoryLoading(true);

      const fd = new FormData();
      
      if (categoryImg) {
        fd.append("image", categoryImg);
      }
      
      const nameObject = {
        eng: nameENG,
        mm: nameMM
      };
      
      fd.append("name", JSON.stringify(nameObject));
      fd.append("parent_id", categoryParentId);

      const updateCategoryURL = `${apiServer.category.update}/${categoryId}`;
      
      try{
        const response = await put(updateCategoryURL, fd);
        const responseData = handleApiSuccess(response, setUpdateCategoryLoading);
        
        navigate('/categories', { replace : true, state: {status: 'success', message: responseData.message} });
      }catch(errors){
        handleApiError(errors, setErrorUpdate, setUpdateCategoryLoading);
      }
    }
  }

  if(getInfoLoading) return <SquareLoading text="Retrieving Category Information" />
  
  if(getInfoError) return <EmptyPage text={getInfoError} />

  if(updateCategoryLoading) return <PopupLoading text='Updating Category...' />


  return (
    <>
      <CategoryForm 
        formTitle={'Update Category'}
        onCreate={handleUpdateCategory}
        onCancel={handleCancelUpdate}
        onSubmitName='Update'
        infoValues={categoryInfoValues}
        errorValues={setErrorValues}
        onUploadImg={handleUploadImage}
        onRemoveImg={handleRemoveImage}
        onChangeValues={handleChangeValue}
        onChangeSelect={handleChooseValue}
      />
      {errorUpdate !== "" && (
        <AdaAlert type="error" message={errorUpdate} />
      )} 
    </>
  )
}

export default UpdateCategory